import { createReducer } from '@ngrx/store';

import { setErrorOn, setLoadingOn, unsetLoadingAndErrorOn } from 'ish-core/utils/ngrx-creators';

import { SalesRepState } from '../sales-rep-store';

import { salesRepActions } from './salesrep.actions';

export const initialState: SalesRepState = {
  loading: false,
};
export const salesRep = createReducer(
  initialState,
  setLoadingOn(salesRepActions.switchCustomer),
  unsetLoadingAndErrorOn(salesRepActions.switchCustomerSuccess),
  setErrorOn(salesRepActions.switchCustomerFail)
);
